var map = {
	"./android.svg": 321,
	"./discord-2.svg": 322,
	"./discord.svg": 323,
	"./facebook.svg": 324,
	"./ios.svg": 325,
	"./linux.svg": 326,
	"./osx.svg": 327,
	"./steam.svg": 328,
	"./twitter.svg": 329,
	"./windows.svg": 330
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 338;



//////////////////
// WEBPACK FOOTER
// ./src/components/simple/Icon ^\.\/.*\.svg$
// module id = 338
// module chunks = 168707334958949